export const COOKIE_CONSENT_STORAGE_KEY = 'myteacher_cookie_consent_v1';
export const COOKIE_CONSENT_EVENT = 'myteacher:cookie-consent';
export const COOKIE_SETTINGS_EVENT = 'myteacher:cookie-settings';

export type CookieChoice = 'accepted' | 'rejected' | null;

/** Выбор пользователя: принял, отклонил или еще не ответил. */
export function getCookieChoice(): CookieChoice {
  if (typeof window === 'undefined') return null;
  try {
    const value = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (value === '1') return 'accepted';
    if (value === '0') return 'rejected';
    return null;
  } catch {
    return null;
  }
}

/** Яндекс Метрика и привязка визита к учетной записи - только после "Принять". */
export function hasCookieConsent(): boolean {
  return getCookieChoice() === 'accepted';
}

export function setCookieChoice(accepted: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, accepted ? '1' : '0');
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT));
}

/** @deprecated используйте setCookieChoice(true) */
export function setCookieConsent(): void {
  setCookieChoice(true);
}

export function openCookieSettings(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(COOKIE_SETTINGS_EVENT));
}

export function subscribeCookieConsent(onChange: () => void): () => void {
  if (typeof window === 'undefined') return () => undefined;

  const handler = () => onChange();
  window.addEventListener(COOKIE_CONSENT_EVENT, handler);
  window.addEventListener('storage', handler);

  return () => {
    window.removeEventListener(COOKIE_CONSENT_EVENT, handler);
    window.removeEventListener('storage', handler);
  };
}
